export default "__VITE_ASSET__d4b4a5aa__"